import * as React from 'react';

export default class LevelLeft extends React.Component<{}, {}> {
	public render() {
		return <div className="level-left">{this.props.children}</div>;
	}
}
